export const API_BASE = 'http://localhost/kokoeco/dev/koko/v1/api/'
export const imageURL = 'http://localhost/kokoeco/dev/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';


// WEBPACK FOOTER //
// ./src/config.js